import {
  Equipment_Read_Typeahead,
  getV1CompaniesCompanyIdEquipmentTypeahead,
  GetV1CompaniesCompanyIdEquipmentTypeaheadData,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { EquipmentTypeahead } from '~hooks/useEquipment/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Equipment_Read_Typeahead,
  EquipmentTypeahead,
  GetV1CompaniesCompanyIdEquipmentTypeaheadData
> & { companyId: string };

export default function AutocompleteEquipmentsTypeahead<T extends FieldValues>({
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteEquipmentsTypeahead"
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        request: getV1CompaniesCompanyIdEquipmentTypeahead,
      }}
      parseFn={(item: Equipment_Read_Typeahead) => {
        const parsed = EquipmentTypeahead.parse(item);

        return { _entity: parsed, label: parsed.name, value: parsed.id };
      }}
    />
  );
}
